<script setup lang="ts">
  import Navbar from '~/components/Navbar/Navbar.vue';
  import RoutedDrawerController from '~/components/shared/RoutedDrawers/RoutedDrawerController.vue';
  import RoutedModalController from '~/components/shared/RoutedModals/RoutedModalController.vue';
  import SupportBot from '~/components/SupportBot/SupportBot.vue';

  const authPaths = ['/login', '/forgot-password', '/reset-password'];
</script>

<template>
  <a-config-provider
    :theme="{
      token: {
        fontFamily: 'Inter',
        colorPrimary: '#2563EB'
      }
    }"
  >
    <Navbar v-if="!authPaths.includes($route.path)" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <SupportBot class="support-bot" />
    <RoutedDrawerController />
    <RoutedModalController />
  </a-config-provider>
</template>

<style>
  .support-bot {
    position: fixed;
    bottom: 24px;
    right: 24px;
    /* Must stay below Ant Design's drawer/modal z-index (1000) so an open drawer or
       modal always renders on top of the support launcher — otherwise the button (and
       its panel) floats above every drawer/modal in the app, covering their content. */
    z-index: 40;
  }
</style>
